import React, { memo } from 'react'
import tw from 'twin.macro'

interface Props {
  /** Tailwind size classes for the block (e.g. `h-4 w-40`); defaults to a full-width text line. */
  className?: any
  /** Rounded like a chip/avatar rather than a card corner. */
  round?: boolean
}

/**
 * A pulsing placeholder block in the design system's neutral tint. Composed into shapes by the
 * `*Skeleton` components; use it directly only for a one-off line. `aria-hidden`: the loading
 * state is announced by the container that renders it, not by each block.
 */
const SkeletonComponent = ({ className, round }: Props) => {
  return (
    <span
      aria-hidden
      css={[
        tw`block animate-pulse bg-shades-100 motion-reduce:animate-none`,
        round ? tw`rounded-full` : tw`rounded-lg`,
        className ?? tw`h-4 w-full`,
      ]}
    />
  )
}

export const Skeleton = memo(SkeletonComponent)
